const ITEMS = [
  "Haircuts",
  "Hot Towel Shaves",
  "Beard Trims",
  "Kids' Cuts",
  "Fades & Line-Ups",
  "Straight Razor",
  "Walk-Ins Welcome",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden bg-barber-surface border-y border-barber-gold/20 py-4" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-2xl sm:text-3xl font-semibold text-[#8FCF6E] px-8 whitespace-nowrap">
              {t}
            </span>
            <span className="text-[#8FCF6E]/50 text-xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
